import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import { Dashboard } from './pages/Dashboard';
import { UserManagement } from './pages/UserManagement';
import { BeneficiaryRegistry } from './pages/BeneficiaryRegistry';
import { OrganizationManagement } from './pages/OrganizationManagement';
import { GuideManagement } from './pages/GuideManagement';
import { ConservationManagement } from './pages/ConservationManagement';
import { HarvestManagement } from './pages/HarvestManagement';
import { TourManagement } from './pages/TourManagement';
import { VesselManagement } from './pages/VesselManagement';
import { ForestCompliance } from './pages/ForestCompliance';
import { SmartIdRfid } from './pages/SmartIdRfid';
import { Reports } from './pages/Reports';
import { UserFlow } from './pages/UserFlow';
import { MobileFieldOfficer } from './pages/MobileFieldOfficer';
import { RolePermission } from './pages/RolePermission';
import { LoginPage } from './pages/LoginPage';
import { BLCManagement } from './pages/BLCManagement';
import { SmartPermitIssuance } from './pages/SmartPermitIssuance';
import { SystemConfiguration } from './pages/SystemConfiguration';
import { MemberManagement } from './pages/MemberManagement';
function AppContent() {
  const location = useLocation();
  const isMobileView = location.pathname.startsWith('/mobile');
  if (isMobileView) {
    return <Routes data-id="element-0" data-mp="2zn6actg9w7ln">
        <Route path="/mobile" element={<MobileFieldOfficer data-id="element-2" data-mp="33m5e4aq9pybi" />} data-id="element-1" data-mp="2znfyebhrc4op" />
      </Routes>;
  }
  return <div className="flex min-h-screen bg-gray-50" data-id="element-3" data-mp="33oi152avuyvf">
      <Sidebar data-id="element-4" data-mp="38l04bxqkep5n" />
      <main className="flex-1 ml-64 p-8" data-id="element-5" data-mp="38k6wsujs7vmg">
        <Routes data-id="element-6" data-mp="3dkl4gbhh13jy">
          <Route path="/" element={<Dashboard data-id="element-8" data-mp="3dlnsmbnesrw6" />} data-id="element-7" data-mp="3dl4n5uey3vz1" />
          <Route path="/users" element={<UserManagement data-id="element-10" data-mp="nvsub5qlapwh" />} data-id="element-9" data-mp="3dirwmsv4gdad" />
          <Route path="/roles" element={<RolePermission data-id="element-12" data-mp="nvasltl5rjh6" />} data-id="element-11" data-mp="nuhiqjqwkdut" />
          <Route path="/beneficiaries" element={<BeneficiaryRegistry data-id="element-14" data-mp="stkjhrzunxwz" />} data-id="element-13" data-mp="sudksdg1hv7q" />
          <Route path="/organizations" element={<OrganizationManagement data-id="element-16" data-mp="35yomiyqxk0x" />} data-id="element-15" data-mp="swqbpg3rzfwx" />
          <Route path="/guides" element={<GuideManagement data-id="element-18" data-mp="38b66v0ldsdg" />} data-id="element-17" data-mp="34x31kk3tf4y" />
          <Route path="/conservation" element={<ConservationManagement data-id="element-20" data-mp="3uc9inv5c9kir" />} data-id="element-19" data-mp="3udknzzefn0bz" />
          <Route path="/harvest" element={<HarvestManagement data-id="element-22" data-mp="d3mlpfjtr3m9" />} data-id="element-21" data-mp="d4o0nv3yoa99" />
          <Route path="/tour" element={<TourManagement data-id="element-24" data-mp="85l28tihl2a9" />} data-id="element-23" data-mp="d3wax0x1p6qw" />
          <Route path="/blc" element={<BLCManagement data-id="element-26" data-mp="86499f6lm69i" />} data-id="element-25" data-mp="85b8qvy8gczt" />
          <Route path="/members" element={<MemberManagement data-id="element-28" data-mp="3gkl9o0qdzc60" />} data-id="element-27" data-mp="83qdt580as1f" />
          <Route path="/smart-permit" element={<SmartPermitIssuance data-id="element-30" data-mp="3bmbehq4nwbke" />} data-id="element-29" data-mp="3glwb3twd07ty" />
          <Route path="/vessels" element={<VesselManagement data-id="element-32" data-mp="3bo4n3ayu55v1" />} data-id="element-31" data-mp="3bncpjulogy24" />
          <Route path="/compliance" element={<ForestCompliance data-id="element-34" data-mp="3qc96kh5pplev" />} data-id="element-33" data-mp="3qb7jfebf98gs" />
          <Route path="/smart-id" element={<SmartIdRfid data-id="element-36" data-mp="3lkr5zu7lpmuf" />} data-id="element-35" data-mp="3qcinlf8s4i8f" />
          <Route path="/reports" element={<Reports data-id="element-38" data-mp="3lj6aa19jvxuz" />} data-id="element-37" data-mp="3ljg2lvi2ih3u" />
          <Route path="/config" element={<SystemConfiguration data-id="element-40" data-mp="2xuddy3p0nnzu" />} data-id="element-39" data-mp="3limv2sbabnkn" />
          <Route path="/user-flow" element={<UserFlow data-id="element-42" data-mp="2svto3s7axs27" />} data-id="element-41" data-mp="2xtbzrqcpeldw" />
        </Routes>
      </main>
    </div>;
}
export function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  if (!isLoggedIn) {
    return <LoginPage onLogin={() => setIsLoggedIn(true)} data-id="element-43" data-mp="18cgfzx81o9n8" />;
  }
  return <BrowserRouter data-id="element-44" data-mp="1d5j9k5ctnj3f">
      <AppContent data-id="element-45" data-mp="1d62ln5fsjd9j" />
    </BrowserRouter>;
}